import { OrderedSet } from 'immutable';
import React from 'react';
import { RFI } from 'records/RFI';
import { RFIForwardActivity } from 'records/RFIForwardActivity';
import { ForwardRFIDiscussionItem } from './ForwardRFIDiscussionItem';

type Props = {
  rfi: RFI;
  selectedDiscussionIds: OrderedSet<string>;
  setSelectedDiscussionIds: (activityid: string) => void;
  canAttach: boolean;
};

const ForwardRFIDiscussion: React.FC<Props> = ({
  rfi,
  selectedDiscussionIds,
  setSelectedDiscussionIds,
  canAttach,
}) => {
  const { forwardactivity, forwardinglist } = rfi;

  const activitySorted = forwardactivity.sort(
    (a1: RFIForwardActivity, a2: RFIForwardActivity) =>
      a2.timestamp - a1.timestamp
  );

  const firstActivity: RFIForwardActivity = rfi.forwardactivity.first();

  return (
    <div className="w100">
      {activitySorted.map((activity: RFIForwardActivity) => (
        <ForwardRFIDiscussionItem
          key={activity.id}
          activity={activity}
          isFirstActivity={firstActivity.timestamp === activity.timestamp}
          selectedDiscussionIds={selectedDiscussionIds}
          setSelectedDiscussionIds={setSelectedDiscussionIds}
          canAttach={canAttach}
          forwardingList={forwardinglist}
          projectid={rfi.projectid}
        />
      ))}
    </div>
  );
};

export default ForwardRFIDiscussion;
